import Vue from 'vue'
import * as firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'

import { rtdbPlugin as VueFire } from 'vuefire'

Vue.use(VueFire)

const config = {
	apiKey: 'AIzaSyDbT80BH2-4Hpz_4DZGExD2D3W6b6X49fs',
	authDomain: 'testfirebase-4ae5d.firebaseapp.com',
	databaseURL: 'https://testfirebase-4ae5d.firebaseio.com',
	projectId: 'testfirebase-4ae5d',
	storageBucket: 'testfirebase-4ae5d.appspot.com',
	messagingSenderId: '90963173342',
	appId: '1:90963173342:web:7287e078290f47f24dc74f'
}

if (!firebase.apps.length) {
  firebase.initializeApp(config)
}
else{
}

export const db = firebase.database()



// WEBPACK FOOTER //
// ./src/plugins/firebase.js